import { useI18n } from "@/common/I18nProvider";

export default function ContactArea() {
  const { messages } = useI18n();
  const contact = messages.contact || {};

  return (
    <>
      <section className="contact-info-section">
        {/* <!-- Divider --> */}
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5">
            {/* <!-- Contact Info Card --> */}
            <div className="col-12 col-md-6 col-lg-5">
              <div className="contact-info-card me-xxl-5 text-white" style={{ color: '#ffffff' }}>
                <h4 className="mb-3 text-white" style={{ color: '#ffffff', fontWeight: '600' }}>
                  {contact.phone?.label || "الهاتف"}
                </h4>
                <h2 className="mb-5 text-white" style={{ color: '#ffffff', fontWeight: '700' }}>
                  {contact.phone?.value || contact.phoneValue || "+218 91 076 7060"}
                </h2>

                <div className="contact-sm-card">
                  <h4 className="mb-3 text-white" style={{ color: '#ffffff', fontWeight: '600' }}>
                    {contact.address?.label || "العنوان"}
                  </h4>
                  <p className="text-white" style={{ color: '#ffffff', opacity: 0.9 }}>
                    {contact.address?.location || contact.location || "طرابلس - ليبيا"}
                  </p>
                  <p className="text-white" style={{ color: '#ffffff', opacity: 0.9 }}>
                    {contact.address?.service || "خدمة العملاء لجميع المدن"}
                  </p>
                </div>

                <hr style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }} />

                <div className="contact-sm-card">
                  <h4 className="mb-3 text-white" style={{ color: '#ffffff', fontWeight: '600' }}>
                    {contact.email?.label || "البريد الإلكتروني"}
                  </h4>
                  <p className="text-white" style={{ color: '#ffffff', opacity: 0.9 }}>
                    {contact.email?.info || contact.emailValue || "info@alburaqint.ly"}
                  </p>
                  <p className="text-white" style={{ color: '#ffffff', opacity: 0.9 }}>
                    {contact.email?.support || "support@alburaqint.ly"}
                  </p>
                </div>

                <hr style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }} />

                <div className="contact-sm-card">
                  <h4 className="mb-3 text-white" style={{ color: '#ffffff', fontWeight: '600' }}>
                    {contact.followUs?.label || "تابعنا"}
                  </h4>
                  {/* <!-- Social Navigation --> */}
                  {/* <div className="social-nav">
                    <a href="#" style={{ color: '#ffffff' }}><i className="ti ti-brand-facebook"></i></a>
                    <a href="#" style={{ color: '#ffffff' }}><i className="ti ti-brand-twitter"></i></a>
                    <a href="#" style={{ color: '#ffffff' }}><i className="ti ti-brand-instagram"></i></a>
                    <a href="#" style={{ color: '#ffffff' }}><i className="ti ti-brand-linkedin"></i></a>
                  </div> */}
                </div>
              </div>
            </div>

            {/* <!-- Contact Info Card --> */}
            <div className="col-12 col-md-6 col-lg-7">
              <div className="section-heading">
                <span className="subtitle">{contact.subtitle || "اتصل بنا"}</span>
                <h2 className="mb-3">{contact.title || "تواصل معنا لتحصل على حلول نقل وزيوت موثوقة بسرعة."}</h2>
                <p className="mb-5">{contact.description || "نعود إليك خلال 24 ساعة بمتطلباتك، ونوفّر عروض أسعار وخطط توريد مصممة لاحتياجات أسطولك."}</p>
              </div>

              <form action="#">
                <div className="row g-4">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <input 
                        type="text" 
                        className="form-control bg-secondary" 
                        placeholder={contact.form?.fullName || "الاسم الكامل"} 
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <input 
                        type="email" 
                        className="form-control bg-secondary" 
                        placeholder={contact.form?.email || "البريد الإلكتروني"} 
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input 
                        type="text" 
                        className="form-control bg-secondary" 
                        placeholder={contact.form?.subject || "موضوع الرسالة"} 
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <textarea 
                        className="form-control bg-secondary" 
                        placeholder={contact.form?.message || "اكتب رسالتك"}
                        rows={5}
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn btn-primary w-100 rounded-3">
                      <span>{contact.form?.submit || "أرسل الرسالة"} <i className="ti ti-arrow-up-right"></i></span>
                      <span>{contact.form?.submit || "أرسل الرسالة"} <i className="ti ti-arrow-up-right"></i></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* <!-- Divider --> */}
        <div className="divider"></div>
      </section>

      {/* <!-- Maps Section --> */}
      <div className="maps-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28244.1302134898!2d-74.1755892587003!3d40.01311247715887!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c10878047171d5%3A0x583d9327f3de1501!2sOcean%20County%20College!5e0!3m2!1sen!2sbd!4v1754374104321!5m2!1sen!2sbd"
          loading="lazy"></iframe>
      </div>
    </>
  )
}
